function ScoreHelperHint() {

  const count = parseInt(localStorage.getItem('scoreDetailsHelperCount'));
  localStorage.setItem('scoreDetailsHelperCount', count + 1);


  return (
    <div class='score-helper-hint-container'>
      <span class='icon icon-arrow-double-up'></span>
      <p>Click for details</p>
    </div>
  );
}

export default ScoreHelperHint;